module.exports = __webpack_public_path__ + "media/64.b3f21644.mp3";